module.exports = __webpack_public_path__ + "img/custom.36ec4d22.png";